<template>

    <div class="MatchDetailPlayer__wrapper">

        <div class="MatchDetailPlayer__holder wrapper">

            <div class="MatchDetailPlayer__team">

                <div class="MatchDetailPlayer">
                    <h3 class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nAF}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nAF)}}</span>&nbsp;{{info.nAL}}</h3>

                    <div class="MatchDetailPlayer__info">

                        <div class="MatchDetailPlayer__country">
                            <img class="small-flag" :src="flagPath + info.cA.toLowerCase() + '.svg'"
                                 :alt="info.cA">
                            <div class="generic-small">{{info.cA}}</div>
                        </div>

                        <div class="MatchDetailPlayer__rank generic-small" v-if="getRank(info.idA)">
                            {{assoc}} Rank:
                            <div class="MatchDetailPlayer__rank__value">{{getRank(info.idA)}}</div>
                            <!-- <div class="MatchDetailPlayer__rank__label" v-if="info.isDoubles == '1'">Doubles<br>ranking</div>
                            <div class="MatchDetailPlayer__rank__label" v-else>Singles<br>ranking</div> -->
                        </div>

                    </div>
                </div>

                <div class="MatchDetailPlayer" v-if="info.isDoubles == '1'">
                    <h3 class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nA2F}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nA2F)}}</span>&nbsp;{{info.nA2L}}</h3>

                    <div class="MatchDetailPlayer__info">

                        <div class="MatchDetailPlayer__country">
                            <img class="small-flag" :src="flagPath + info.cA2.toLowerCase() + '.svg'"
                                 :alt="info.cA2">
                            <div class="generic-small">{{info.cA2}}</div>
                        </div>

                        <div class="MatchDetailPlayer__rank generic-small" v-if="getRank(info.idA2)">
                            {{assoc}} Rank:
                            <div class="MatchDetailPlayer__rank__value">{{getRank(info.idA2)}}</div>
                            <!-- <div class="MatchDetailPlayer__rank__label">Doubles<br>ranking</div> -->
                        </div>

                    </div>
                </div>

            </div>

            <div class="MatchDetailPlayer__separator"></div>

            <div class="MatchDetailPlayer__team">

                <div class="MatchDetailPlayer">
                    <h3 class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nBF}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nBF)}}</span>&nbsp;{{info.nBL}}</h3>

                    <div class="MatchDetailPlayer__info">

                        <div class="MatchDetailPlayer__country">
                            <img class="small-flag" :src="flagPath + info.cB.toLowerCase() + '.svg'"
                                 :alt="info.cB">
                            <div class="generic-small">{{info.cB}}</div>
                        </div>

                        <div class="MatchDetailPlayer__rank generic-small" v-if="getRank(info.idB)">
                            {{assoc}} Rank:
                            <!-- <div class="MatchDetailPlayer__rank__label" v-if="info.isDoubles == '1'">Doubles<br>ranking</div>
                            <div class="MatchDetailPlayer__rank__label" v-else>Singles<br>ranking</div> -->
                            <div class="MatchDetailPlayer__rank__value">{{getRank(info.idB)}}</div>
                        </div>

                    </div>
                </div>

                <div class="MatchDetailPlayer" v-if="info.isDoubles == '1'">
                    <h3 class="MatchDetailPlayer__name"><span class="MatchDetailPlayer__name__fn">{{info.nB2F}}</span><span class="MatchDetailPlayer__name__i">{{initial(info.nB2F)}}</span>&nbsp;{{info.nB2L}}</h3>

                    <div class="MatchDetailPlayer__info">

                        <div class="MatchDetailPlayer__country">
                            <img class="small-flag" :src="flagPath + info.cB2.toLowerCase() + '.svg'"
                                 :alt="info.cB2">
                            <div class="generic-small">{{info.cB2}}</div>
                        </div>

                        <div class="MatchDetailPlayer__rank generic-small" v-if="getRank(info.idB2)">
                            {{assoc}} Rank:
                            <div class="MatchDetailPlayer__rank__value">{{getRank(info.idB2)}}</div>
                            <!-- <div class="MatchDetailPlayer__rank__label">Doubles<br>ranking</div> -->
                        </div>

                    </div>
                </div>

            </div>

        </div>

    </div>


</template>

<script>
    import axios from 'axios'

    export default {
        props: ['info', 'match', 'assoc', 'flagPath'],
        data() {
            return {
                players: window.all_players,
                h2h: [],
                isSingle: false,
                singles: ["QS", "MS", "RS", "LS"],
            }
        },
        created() {
            this.getH2H()



        },
        mounted() {
            // console.log('match', this.match.substring(0, 2))
            if(this.singles.includes(this.match.substring(0, 2))){

                this.isSingle = true
            }
        },
        methods: {
            getH2H() {

                if( this.assoc == 'atp' ){

                    axios.get(`${window.feed_ip}/${this.assoc}/update/h2h/${window.tournament}/${this.info.idA}/${this.info.idB}`).then(response => {

                        this.h2h = response.data

                    }).catch(function (error) {
                        console.log(error);
                    });

                } else {

                    axios.get(`${window.feed_ip}/get/${this.assoc}/${window.tournament}/${this.match}-h2h`).then(response => {

                        this.h2h = response.data

                    }).catch(function (error) {
                        console.log(error);
                    });

                }

            },
            playerH2H(player) {

                if (this.h2h == null) {
                    return '-'
                }

                if (this.h2h[player] == null) {
                    return '-'
                }

                return this.h2h[player]

            },
            playerH2HPercent(player) {

                if (this.h2h == null) {
                    return false
                }

                if (this.h2h[player] == null) {
                    return false
                }

                if (this.h2h[player] == '0') {
                    return '0'
                }

                return Math.round(parseInt(this.h2h[player]) / (parseInt(this.h2h[0]) + parseInt(this.h2h[1])) * 100)

            },
            getRank(playerId) {
                let player = this.findPlayerById(playerId)

                if (!player) {
                    return 'N/A'
                }

                if (this.info.isDoubles == '1') {
                    return player.double_rank
                }

                return player.single_rank

            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            findPlayerById(playerId) {
                let found = this.players.filter(player => player.player_id == playerId)

                if (found.length == 1) {
                    return found[0]
                }

                return false
            }
        }
    }
</script>
